<template>
<div><!--ini -->
  <v-row >
       <!-- <v-btn v-for="abu of miabuelo" :key="abu.id" @click="nombrefuncion(abu.id)">{{abu.name}}</v-btn> <br> -->
  <v-col cols="2" class="">
         <v-col cols="12">
          <v-btn class="mx-2 pl-1" id="view-fullscreen" fab dark x-small color="warning" ><v-icon small > fa-desktop</v-icon></v-btn>
          <v-btn class="mx-2 pl-1" id="cancel-fullscreen" fab dark x-small color="info" ><v-icon small > fa-desktop</v-icon></v-btn>
          <v-btn class="primary mt-2"  @click="volverAtras">Volver</v-btn>
    </v-col>
     <template  >
  <v-container fluid>
    <v-row wrap style="max-height: 700px" class="overflow-y-auto">
      <!-- -->
       <v-col v-for="abu of miabuelo" :key="abu.id" @click="nombrefuncion(abu.id);loadPanel('panelcol1')"  cols="12">
        <v-img class="c" height="130px" width="230px"
           :key="abu.id"
           :src="abu.name.src"
           
        ></v-img>
      </v-col> 
      <v-alert type="warning" outlined v-if="diapositivas.length===0">
        Aún no existen diapositivas creadas.
      </v-alert>
      <v-col cols="12" v-for="(item,index) of diapositivas" :key="index">
        <v-card @click="verDiapositivaPregunta(item,index)" class="diapositiva" v-if="item.tipo==='PM' || item.tipo==='PU' || item.tipo==='PV'">
          <span v-html="item.titulo" class="text-center" style="font-size:10px"></span>
            <v-img  src="@/assets/iconos/PU.svg" v-if="item.tipo==='PU'" class="white--text align-end"></v-img>
            <v-img  src="@/assets/iconos/PM.svg" v-if="item.tipo==='PM'" class="white--text align-end"></v-img>
            <v-img  src="@/assets/iconos/VF.svg" v-if="item.tipo==='PV'" class="white--text align-end"></v-img>
        </v-card >
      <v-card v-else @click="verDiapositiva(item)">
            <span v-html="item.titulo" class="text-center" style="font-size:10px"></span>
            <v-img  src="@/assets/iconos/1-COL.jpg" v-if="item.tipo==='C1'" class="white--text align-end"></v-img>
            <v-img  src="@/assets/iconos/2-COL.jpg" v-if="item.tipo==='C2'" class="white--text align-end"></v-img>
            <v-img  src="@/assets/iconos/3-COL.jpg" v-if="item.tipo==='C3'" class="white--text align-end"></v-img>
            <v-img  src="@/assets/iconos/4-COL.jpg" v-if="item.tipo==='C4'" class="white--text align-end"></v-img>
      </v-card>
      </v-col>

    </v-row>
  </v-container>
</template>
    
  </v-col>
  <!-- end side -->
  <v-col cols="10" class="fondo">
    <template>
          <!-- <v-alert type="error" v-if="msj" dismissible>  {{text}}   </v-alert> -->
      <!-- -->
      <v-col cols="12" md="">
        <VistaCol01 v-if="panelcol1" :presentacion="diapost"></VistaCol01>
        <VistaCol02 v-if="panelcol2" :presentacion="diapost"></VistaCol02>
        <VistaCol03 v-if="panelcol3" :presentacion="diapost"></VistaCol03>
        <VistaCol04 v-if="panelcol4" :presentacion="diapost"></VistaCol04>
        <VistaPre1 v-if="contenidopreg1" :presentacion="pregunta" :respuestaVerdadera="rv" :respuestaUnica="ru" :respuestas="rm" @comprobar="validarRespuesta" :opciones="opcs" :validar="valid" ></VistaPre1>
      </v-col>    
      <!-- -->
</template>

  </v-col>
</v-row>

<!-- --> 

<!-- -->
<!-- <pre>{{$data}}</pre> -->
</div><!--end -->
</template>

<script>
//import IndexTemplate from '@/components/IndexTemplate.vue';

import VistaCol01 from '@/views/ContenidoDiapositivas/VistasDiapositivas/VistaCol01.vue'
import VistaCol02 from '@/views/ContenidoDiapositivas/VistasDiapositivas/VistaCol02.vue'
import VistaCol03 from '@/views/ContenidoDiapositivas/VistasDiapositivas/VistaCol03.vue'
import VistaCol04 from '@/views/ContenidoDiapositivas/VistasDiapositivas/VistaCol04.vue'
import VistaPre1  from '@/views/ContenidoDiapositivas/VistasDiapositivas/VistaPre1.vue'

import axios from "../../helpers/axios";
import { mapGetters, mapActions} from 'vuex';
export default {
  name: 'contenidodiapositiva',
  props:['diapositivas'],
  
  data() {
    return {
    diapost:[],
    paramComponente:{ 'id_submodulo':22, "id_modulo": 4},
    pregunta:[],
    rv:false,
    ru:false,
    rm:false,
    opcs:false,
    valid:true,
     hidentemplate: true,
    //  msj:false,
    //  text:'',
    //  tipo:'',
      api1:[],
      variable:-1,
      vista:false,
     panelcol1:false,
     panelcol2: false,
     panelcol3: false,
     panelcol4: false,
     contenidopreg1: false,
     contenidopreg2: false,
     contenidopreg3: false,
     contenidopreg4: false,
     contenidopreg5: false,
     contenidopreg6: false,
     contenidopreg7: false,
     contenidopreg8: false,
     tipoComponente :'',
     prueba:[],
     vef:0,
     vif:0,
     ruta:{
       clases_id: 0,
         
       temas_id: 0,

       cursos_id: 0,

     },

      mirror:{
            contenido:{
            tipo: this.tipo,
            id_usuario: sessionStorage.id, // 25-02-2020. Robert. Se elimina la asignación estatica del Id del usuario y se agraga el Seteo de la variable en session
            id_colegio: sessionStorage.id_colegio, // 25-02-2020. Robert. Se elimina la asignación estatica del Id del colegio y se agraga el Seteo de la variable en session
            id_clase: 0, // 25-02-2020. Robert. Se elimina la asignación estatica del Id de la clase en session y se agraga el Seteo de la variable en 0
            titulo: '',
            subtitulo: '',
            seccion1: [],
            seccion2: [],
            desc_contenido: '',
            dificultad: 0,
            panelsw1: true, //panelsw1
            panelsw2: true //panelsw2
               },
             
            },
      miabuelo: 0, // 25-02-2020. Robert. Se crea con el fin de probar corrección de error


    
    };

  },
 
  mounted() {
      
      this.fullsc()
    },

    created() {

    this.actualizarParamentro()
  
  },

  computed: {
        ...mapGetters('login', [ 'componenteEvento'])
      },


  methods: {

    ...mapActions('login',['parametroComponente'] ),


  actualizarParamentro() {
                //console.log( `parametroComponente ${JSON.stringify(this.paramComponente)}`)
                 this.parametroComponente(this.paramComponente)
            },
    /******volver atras **** */
    volverAtras(){
      this.$emit('volver');
    },
    validarRespuesta(tipo){
      if(tipo ==='prU'){
        this.ru = true
      }else if(tipo === 'prM'){
        this.rm = true
        this.opcs = false
        this.valid = false
      }
        
    },
    /* ver diapositiva ****/
    async verDiapositiva(item){
      if(this.vif != item.id){
          var id = item.id
          try{
            let response = await axios.get("/manager/contenido/"+id+"");
            this.prueba = response.data
            this.diapost = JSON.parse(this.prueba[0].json_contenido)
            this.rv = false
            this.ru = false
            this.verificarColumnas(item.tipo)
            this.vif = item.id
            //console.log('dipost====>>>'+JSON.stringify(this.diapost.seccion1));
          }catch(error){
            console.log(error);
          }
      }else{
        alert('Ya estás en esta diapositiva.');
      }
     
    },
    async verDiapositivaPregunta(item){
      this.valid = true
      this.ru = false
      this.rm = false
      this.opcs = true
      if(this.vif != item.id){
         var id = item.id
       try{
         let response =await axios.get("/manager/contenido/preg/"+id+"");
          this.pregunta = response.data
          this.verificando(item.tipo);
          this.vif = item.id
          //console.log('pregunta====>>>'+JSON.stringify(this.pregunta));
       }catch(error){
         console.log(error)
       }
      }else{
        alert('ya estas en esta diapositiva');
      }
     
    },

    verificarColumnas(tipo){
        if(tipo === 'C1'){
          this.panelcol1 = true
          this.panelcol3 = false
          this.panelcol2 = false
           this.contenidopreg1 = false
        }else if(tipo === 'C2'){
          this.panelcol1 = false
          this.panelcol3 = false
          this.panelcol2 = true
           this.contenidopreg1 = false
        }else if(tipo === 'C3'){
           this.panelcol1 = false
          this.panelcol2 = false
          this.panelcol3 = true
           this.contenidopreg1 = false
        }
    },
       verificando(tipo){
          if(tipo==='PU' || tipo==='PM' || tipo==='PV'){
            this.contenidopreg1 = true
            this.panelcol1 = false
             this.panelcol3 = false
             this.panelcol2 = false
          }
       },
    nombrefuncion(id){
       alert('X--X.-.-->'+id);
    },

    async loadPanel (tipoComponente) {
              this.loadPanel
               
               this.panelcol1 = false
               this.panelcol2 = false
               this.panelcol3 = false
               this.panelcol4 = false
               this.contenidopreg1 = false
               this.contenidopreg2 = false
               this.contenidopreg3 = false
               this.contenidopreg4 = false
               this.contenidopreg5 = false
               this.contenidopreg6 = false
               this.contenidopreg7 = false
               this.contenidopreg8 = false
               

             switch (tipoComponente) {
           
                  case 'panelcol1':
                    this.panelcol1 = true;
                    this.panelcase1 = 'panelcol1';
                   break;
                   case 'panelcol2':
                    this.panelcol2 = true;
                    this.panelcase2 = 'panelcol2';
                   break;
                   case 'panelcol3':
                    this.panelcol3 = true;
                    this.panelcase3 = 'panelcol3';
                   break;
                   case 'panelcol4':
                    this.panelcol4 = true;
                    this.panelcase4 = 'panelcol4';
                   break;
                   case 'panelcol5':
                    this.panelcol5 = true;
                    this.panelcase5 = 'panelcol5';
                   break;
                   case 'panelcol6':
                    this.panelcol6 = true;
                    this.panelcase6 = 'panelcol6';
                   break;
                   case 'panelcol7':
                    this.panelcol7 = true;
                    this.panelcase7 = 'panelcol7';
                   break;
                    case 'panelcol8':
                    this.panelcol8 = true;
                    this.panelcase8 = 'panelcol8';
                   break;
                    case 'panelcol9':
                    this.panelcol9 = true;
                    this.panelcase9 = 'panelcol9';
                   break;
                    case 'panelcol10':
                    this.panelcol10 = true;
                    this.panelcase10 = 'panelcol10';
                   break;
                    case 'panelcol11':
                    this.panelcol11 = true;
                    this.panelcase11 = 'panelcol11';
                   break;
                   case 'contenidopreg1':
                    this.contenidopreg1 = true;
                    this.panelcase12 = 'contenidopreg1';
                   break;
                   case 'contenidopreg2':
                    this.contenidopreg2 = true;
                    this.panelcase13 = 'contenidopreg2';
                   break;
                   case 'contenidopreg3':
                    this.contenidopreg3 = true;
                    this.panelcase14 = 'contenidopreg3';
                   break;
                   case 'contenidopreg4':
                    this.contenidopreg4 = true;
                    this.panelcase15 = 'contenidopreg4';
                   break;
                   case 'contenidopreg5':
                    this.contenidopreg5 = true;
                    this.panelcase16 = 'contenidopreg5';
                   break;
                   case 'contenidopreg6':
                    this.contenidopreg6 = true;
                    this.panelcase17 = 'contenidopreg6';
                   break;
                   case 'contenidopreg7':
                    this.contenidopreg7 = true;
                    this.panelcase18 = 'contenidopreg7';
                   break;
                  default:
                  break; 
              }


          },   
    
    fullsc: function(){
       
          var viewFullScreen = document.getElementById("view-fullscreen");
    if (viewFullScreen) {
        viewFullScreen.addEventListener("click", function () {
            var docElm = document.documentElement;
            if (docElm.requestFullscreen) {
                docElm.requestFullscreen();
            }
            else if (docElm.msRequestFullscreen) {
                docElm = document.body; //overwrite the element (for IE)
                docElm.msRequestFullscreen();
            }
            else if (docElm.mozRequestFullScreen) {
                docElm.mozRequestFullScreen();
            }
            else if (docElm.webkitRequestFullScreen) {
                docElm.webkitRequestFullScreen();
            }
        }, false);
    }

          var cancelFullScreen = document.getElementById("cancel-fullscreen");
    if (cancelFullScreen) {
        cancelFullScreen.addEventListener("click", function () {
            if (document.exitFullscreen) {
                document.exitFullscreen();
            }
            else if (document.msExitFullscreen) {
                document.msExitFullscreen();
            }
            else if (document.mozCancelFullScreen) {
                document.mozCancelFullScreen();
            }
            else if (document.webkitCancelFullScreen) {
                document.webkitCancelFullScreen();
            }
        }, false);
    }
    

    var fullscreenState = document.getElementById("fullscreen-state");
    if (fullscreenState) {
        document.addEventListener("fullscreenchange", function () {
            fullscreenState.innerHTML = (document.fullscreenElement)? "" : "not ";
        }, false);
        
        document.addEventListener("msfullscreenchange", function () {
            fullscreenState.innerHTML = (document.msFullscreenElement)? "" : "not ";
        }, false);
        
        document.addEventListener("mozfullscreenchange", function () {
            fullscreenState.innerHTML = (document.mozFullScreen)? "" : "not ";
        }, false);
        
        document.addEventListener("webkitfullscreenchange", function () {
            fullscreenState.innerHTML = (document.webkitIsFullScreen)? "" : "not ";
        }, false);
    }

    

    },

},

  components: {
    VistaCol01,
    VistaCol02,
    VistaCol03,
    VistaCol04,
    VistaPre1 

  }
}
    

</script>


<style>

/* Maquetacion */

.a{
    background-color: brown;
}
.b{
    background-color: rgb(15, 221, 170);
}
.c{
    background-color: blueviolet;
}
.d{
    background-color: rgb(3, 86, 124);
}

.fondo{
    margin:0;
    height:auto;
    background-image: url("../../assets/fondo_template.svg"); /* The image used */
    background-color: #cccccc; /* Used if the image is unavailable */
    background-position: center; /* Center the image */
    background-repeat: no-repeat; /* Do not repeat the image */
    background-size: cover; /* Resize the background image to cover the entire container */
}
.diapositiva{
  width: 200px;
  transition: width 4s;
  cursor: pointer;
}


</style>